import React, { useState, useEffect } from 'react';
import { useApi } from '../../apiHelpers';
import dayjs from 'dayjs';
import Panel from '../../components/ui/Panel';
import { Progress } from '../../components/ui/Progress';

const UserActivitySummaryModule = () => {
  const api = useApi();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await api.get('/maintenance/recent/all', { silent: true });
        // Aggregate by user
        const userMap = {};
        (data || []).forEach(item => {
          const name = item.firstname || 'Unknown';
          if (!userMap[name]) {
            userMap[name] = { name, count: 0, lastActive: item.last_touched };
          }
          userMap[name].count++;
          if (dayjs(item.last_touched).isAfter(dayjs(userMap[name].lastActive))) {
            userMap[name].lastActive = item.last_touched;
          }
        });
        const sorted = Object.values(userMap).sort((a, b) => b.count - a.count);
        setUsers(sorted);
      } catch { /* silent */ }
      setLoading(false);
    };
    fetch();
  }, []);

  if (loading || users.length === 0) return null;

  const maxCount = users[0]?.count || 1;

  return (
    <Panel title="User Activity" titleStyle="section" accent="primary" lit level={3}>
      <div className="space-y-2">
        {users.map(user => {
          return (
            <div key={user.name} className="flex items-center gap-3">
              <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center flex-shrink-0">
                <span className="text-[10px] font-bold text-on-surface-variant uppercase">{user.name[0]}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline justify-between mb-0.5">
                  <span className="text-xs font-medium text-on-surface">{user.name}</span>
                  <span className="text-[10px] text-on-surface-variant tabular-nums">{user.count} actions</span>
                </div>
                <Progress value={user.count} max={maxCount} label={`${user.name} actions`} size="sm" />
              </div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};

export default UserActivitySummaryModule;
